import { FC } from 'react';
import * as statisticsStyles from './detailed-statistics.css.ts';
import { TournamentsSection } from './tournaments-section/tournaments-section.tsx';

export const DetailedStatistics: FC<{ userId: string }> = ({ userId }) => {
  return (
    <div className={statisticsStyles.detailedStatisticsContainer}>
      <TournamentsSection userId={userId} />
    </div>
  );
};
